import ReserveScreen from './components/ReserveScreen'

export default {
  path: '/reserva',
  name: 'Reserve',
  component: ReserveScreen
}



// WEBPACK FOOTER //
// ./src/app/screens/Reserve/index.js